import { getApi, postApi } from "../../Shared/Services/RestService";
import {
  AccountDeletionRequest,
  AccountDeletionStats,
  AccountPage,
  DeactivatedAccount,
} from "../Types/AccountDeletionType";

/**
 * SUPER_ADMIN account lifecycle surface: deletion requests, and every deactivated account.
 * Approval is the only irreversible operation in the account lifecycle, so these endpoints
 * sit behind a SUPER_ADMIN gate server-side as well as in the menu.
 */
export const getAccountDeletionRequests = (
  status: string | undefined,
  page: number,
  size: number,
) => {
  return getApi<AccountPage<AccountDeletionRequest>>("/admin/account-deletion-requests", {
    status: status || undefined,
    page,
    size,
  });
};

export const getAccountDeletionStats = () => {
  return getApi<AccountDeletionStats>("/admin/account-deletion-requests/stats");
};

/** Permanently removes the account and e-mails the requester. Irreversible. */
export const approveAccountDeletionRequest = (id: string) => {
  return postApi<AccountDeletionRequest>(`/admin/account-deletion-requests/${id}/approve`, {});
};

/** Refuses the request and returns the account to ACTIVE. */
export const rejectAccountDeletionRequest = (id: string, note: string) => {
  return postApi<AccountDeletionRequest>(`/admin/account-deletion-requests/${id}/reject`, { note });
};

/**
 * Deactivated accounts for one role. Candidates and recruiters are separate lists — the
 * only thing they share is being switched off.
 */
export const getDeactivatedAccounts = (
  role: 'CANDIDATE' | 'RECRUITER',
  page: number,
  size: number,
) => {
  return getApi<AccountPage<DeactivatedAccount>>("/admin/deactivated-accounts", {
    role,
    page,
    size,
  });
};

/** Returns an account to ACTIVE and clears the suspension stamp. Reversible. */
export const reactivateDeactivatedAccount = (userId: string) => {
  return postApi<DeactivatedAccount>(`/admin/deactivated-accounts/${userId}/reactivate`, {});
};
